import * as React from 'react'
import { memo } from 'react'
const SvgHome = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.117 12">
    <path d="M11.688 3.429h1.091V2.338h-1.091Zm0 3.117h1.091V5.455h-1.091Zm0 3.117h1.091V8.572h-1.091ZM0 12V5.727l4.442-3.156 4.442 3.156V12h-3.04V8.26H3.039V12Zm10.442 0V4.948l-4.052-2.9V0h8.727v12Z" />
  </svg>
)
const Memo = memo(SvgHome)
export default Memo
